const appConfig = {
  // backend url (with slash at end)
  URL: 'https://multihomeapp.hu/',
  CONTACTEMAIL: 'info@multihomeapp.hu',
  DEFAULTLANG: 'hu',
  LIMIT_ITEMS: 50,
};

export default appConfig;
